<template>
<div>

    <div class="content-wrapper" style="min-height: 873px;">
        <div>
            <!-- Main content -->
            <section class="content">
                <section class="col-lg-12 connectedSortable">

                    <div class="box">
                        <div class="box-header">
                            <h3 class="box-title">{{ $t("USERS.USERS") }}</h3>
                        </div>

                        <div class="box-body">
                            <div v-if="loading == false">
                                <div class="box box-primary direct-chat direct-chat-primary">
                                    <div class="box-body">
                                        <vue-good-table :columns="columns" :rows="users" :searchOptions="{
                                    enabled: true,
                                    trigger: 'enter',
                                    placeholder: this.$t('SEARCH'),
                                  }" :pagination-options="{
                                      enabled: true,
                                      dropdownAllowAll: false,
                                      nextLabel: $t('TRANSACTION_TABLE.NEXT') ,
                                      prevLabel:$t('TRANSACTION_TABLE.BACK') ,
                                      ofLabel: $t('TRANSACTION_TABLE.OF') ,
                                      rowsPerPageLabel:$t('TRANSACTION_TABLE.ROWS_PER_PAGES'),
                                        
                                       }" styleClass="vgt-table condensed">
                                            <template slot="table-column" slot-scope="props">
                                                <th v-if="props.column.field == 'date'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'name'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'lastname'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'email'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'roll'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'edit'"> {{ props.column.label | translate }}</th>
                                                <th v-if="props.column.field == 'delete'"> {{ props.column.label | translate }} </th>

                                            </template>
                                            <template slot="table-row" scope="props">
                                                <td v-if="props.column.field == 'date'"> {{props.row.date | formatDate}}</td>
                                                <td v-if="props.column.field == 'name'"> {{props.row.name}}</td>
                                                <td v-if="props.column.field == 'lastname'"> {{props.row.lastname}}</td>
                                                <td v-if="props.column.field == 'email'"> {{props.row.email}}</td>
                                                <td v-if="props.column.field == 'roll'"> {{props.row.roll | translate}}</td>

                                                <td v-if="props.column.field == 'edit'">

                                                    <router-link class="btn btn-primary btn-sm" :to="{ name:'updateUser', params:{id:props.row._id} }">
                                                        <span><i class="fa fa-pencil"></i></span>
                                                    </router-link>

                                                </td>

                                                <td v-if="props.column.field == 'delete'">

                                                    <button class="btn btn-danger btn-sm" @click="remove(props.row._id)"><span><i class="fa fa-trash"></i></span></button>

                                                </td>

                                            </template>
                                        </vue-good-table>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <center>
                                    <div class="fa fa-spinner fa-pulse text-blue" style="font-size:100px;"></div>
                                </center>
                            </div>
                        </div>
                        <!-- /.box-body -->
                    </div>

                </section>

            </section>
        </div>
        <div style="clear:both;"></div>
    </div>

</div>
</template>

<script>
import swal from "sweetalert";
export default {
    name: "users",
    data() {
        return {
            users: [],
            loading: false,
            columns: [{
                    label: "USERS.CREATION DATE",
                    field: "date",

                    filterable: true
                },
                {
                    label: "USERS.NAME",
                    field: "name",
                    type: "string",
                    filterable: true
                },
                {
                    label: "USERS.LASTNAME",
                    field: "lastname",
                    type: "string",
                    filterable: true
                },
                {
                    label: "Email",
                    field: "email",
                    type: "email",
                    filterable: true
                },
                {
                    label: "USERS.ROLL",
                    field: "roll",
                    type: "string",
                    filterable: true
                },

                {
                    label: "EDIT",
                    field: "edit",
                    type: "string",
                    html: true,
                    filterable: true
                },
                {
                    label: "DELETE",
                    type: "string",
                    field: "delete",
                    html: true,
                    filterable: true
                }
            ]
        };
    },
    created() {
        this.getAll(JSON.parse(this.$store.getters.user).token);
    },
    methods: {
        mySearchFn(row, col, cellValue, searchTerm) {

            // console.log(searchTerm)
        },
        async getAll(token) {
            let self = this;
            self.loading = true;
            try {
                let allUsers = await self.$store.state.services.userService.getAll(
                    token
                );
                this.users = allUsers.data;

                self.loading = false;
            } catch (reason) {
                swal({
                    title: reason.response.data.error,
                    icon: "warning",
                    dangerMode: false
                }).then(clicket => {
                    self.loading = false;
                });
            }
        },
        remove(id) {
            let self = this;

            swal({
                title: this.$t("ARE_YOU_SURE?"),
                text: this.$t(`REMOVE_USER_QUESTION`),
                icon: "warning",
                buttons: [this.$t("No, CANCEL"), this.$t("YES, REMOVE")],
                dangerMode: true
            }).then(async willDelete => {
                if (willDelete) {
                    try {
                        self.loading = true;
                        let response = await self.$store.state.services.userService.remove(
                            id,
                            JSON.parse(self.$store.getters.user).token
                        );
                        let toRemove = self.users.find(element => {
                            return element._id == id;
                        });
                        let newAll = [];
                        for (const user of self.users) {
                            if (user != toRemove) {
                                newAll.push(user);
                            }
                        }
                        self.users = newAll;
                        self.loading = false;

                        swal(response.data.message, {
                            icon: response.data.icon
                        });
                    } catch (reason) {
                        console.log(reason);
                        swal({
                            title: this.$t("USERS.THIS USER COULDNT´T BE REMOVED"),
                            text: `${this.$t("REASON")}: ${reason.response.data.error}`,
                            icon: "error"
                        });
                    } finally {
                        self.loading = false;
                    }
                }
            });
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/partials/users.vue